import React, { useContext, useRef, useState } from "react";

// styles
import Style from "./AdminDashboardProjectTeam.module.css";

// context
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";

const AdminDashboardProjectTeam = () => {
  const { selectedProject, projectEditable, setUpdateProjectData } = useContext(
    AdminDashboardContext
  );

  const [isAddingTeamMemberContainerOpen, setIsAddingTeamMemberContainerOpen] =
    useState(false);
  const [newOtherProject, setNewOtherProject] = useState([]);
  const [error, setError] = useState("");

  // New state for editing
  const [editingMember, setEditingMember] = useState(null);
  const [editedData, setEditedData] = useState({
    nameSurname: "",
    email: "",
    thisProjectPercentage: 0,
    otherProjects: [],
  });
  const [editingOtherProject, setEditingOtherProject] = useState({
    otherProjectName: "",
    otherProjectPercentage: "",
  });

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const percentageRef = useRef(null);
  const otherProjectName = useRef(null);
  const otherProjectPercentage = useRef(null);

  // Function to start editing a member
  const startEditingMember = (member) => {
    setEditingMember(member);
    setEditedData({
      nameSurname: member.nameSurname,
      email: member.email,
      thisProjectPercentage: member.thisProjectPercentage,
      otherProjects: [...(member.otherProjects || [])],
    });
    setError("");
  };

  // Function to cancel editing
  const cancelEditing = () => {
    setEditingMember(null);
    setEditedData({
      nameSurname: "",
      email: "",
      thisProjectPercentage: 0,
      otherProjects: [],
    });
    setError("");
  };

  // Function to handle changes in edited fields
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prev) => ({
      ...prev,
      [name]: name === "thisProjectPercentage" ? Number(value) : value,
    }));
  };

  // Function to handle changes in other project being edited
  const handleEditOtherProjectChange = (e) => {
    const { name, value } = e.target;
    setEditingOtherProject((prev) => ({
      ...prev,
      [name]: name === "otherProjectPercentage" ? value : value,
    }));
  };

  // Function to add other project to edited data
  const addOtherProjectToEdit = () => {
    const { otherProjectName, otherProjectPercentage } = editingOtherProject;

    if (!otherProjectName || !otherProjectPercentage) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (otherProjectPercentage <= 100 && otherProjectPercentage >= 0) {
      setEditedData((prev) => ({
        ...prev,
        otherProjects: [
          ...prev.otherProjects,
          {
            otherProjectName,
            otherProjectPercentage: Number(otherProjectPercentage),
          },
        ],
      }));

      // Reset input fields
      setEditingOtherProject({
        otherProjectName: "",
        otherProjectPercentage: "",
      });
      setError("");
    } else {
      setError("Postotak radnog vremena mora biti veći ili jednak nuli.");
    }
  };

  // Function to remove other project from edited data
  const removeOtherProjectFromEdit = (index) => {
    setEditedData((prev) => ({
      ...prev,
      otherProjects: prev.otherProjects.filter((_, i) => i !== index),
    }));
  };

  // Function to save edited member changes
  const saveEditedMember = () => {
    const { nameSurname, email, thisProjectPercentage } = editedData;

    if (!nameSurname || !email || !thisProjectPercentage) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (thisProjectPercentage <= 100 && thisProjectPercentage >= 0) {
      const newTeamMembers = selectedProject.projectTeam.map((member) =>
        member === editingMember ? { ...editedData } : member
      );

      selectedProject.projectTeam = newTeamMembers;
      setUpdateProjectData((prevState) => ({
        ...prevState,
        projectTeam: newTeamMembers,
      }));

      // Reset editing state
      setEditingMember(null);
      setEditedData({
        nameSurname: "",
        email: "",
        thisProjectPercentage: 0,
        otherProjects: [],
      });
      setError("");
    } else {
      setError("Postotak radnog vremena mora biti veći ili jednak nuli.");
    }
  };

  const deleteTeamMember = (member) => () => {
    const newTeamMembers = selectedProject.projectTeam.filter(
      (teamMember) => teamMember !== member
    );

    selectedProject.projectTeam = newTeamMembers;
    setUpdateProjectData((prevState) => ({
      ...prevState,
      projectTeam: newTeamMembers,
    }));
  };

  const addNewTeamMember = () => {
    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const thisProjectPercentage = percentageRef.current.value;

    if (!name || !email || !thisProjectPercentage) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (thisProjectPercentage <= 100 && thisProjectPercentage >= 0) {
      const newTeamMembers = selectedProject.projectTeam;
      newTeamMembers.push({
        nameSurname: name,
        email: email,
        thisProjectPercentage: Number(thisProjectPercentage),
        otherProjects: newOtherProject,
      });

      setNewOtherProject([]);

      selectedProject.projectTeam = newTeamMembers;
      setUpdateProjectData((prevState) => ({
        ...prevState,
        projectTeam: newTeamMembers,
      }));
      nameRef.current.value = "";
      emailRef.current.value = "";
      percentageRef.current.value = "";
      otherProjectName.current.value = "";
      otherProjectPercentage.current.value = "";
      setError("");
    } else {
      setError("Postotak radnog vremena biti veći ili jednak nuli");
    }
  };

  const addOtherProjectsButton = () => {
    const name = otherProjectName.current.value;
    const percentage = otherProjectPercentage.current.value;

    if (!name || !percentage) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (percentage <= 100 && percentage >= 0) {
      const newOtherProjects = [
        ...newOtherProject,
        {
          otherProjectName: name,
          otherProjectPercentage: percentage,
        },
      ];

      setNewOtherProject(newOtherProjects);
      otherProjectName.current.value = "";
      otherProjectPercentage.current.value = "";
      setError("");
    } else {
      setError("Postotak radnog vremena mora biti veći ili jednak nuli.");
    }
  };

  const deleteOtherProject = () => {
    const newOtherProjects = newOtherProject.filter(
      (project, index) => index !== newOtherProject.length - 1
    );
    setNewOtherProject(newOtherProjects);
  };

  return (
    <div className={Style.AdminDashboardProjectTeamContainer}>
      {selectedProject?.projectTeam?.map((member) => (
        <div
          className={Style.AdminDashboardProjectTeamMember}
          key={member.email}
        >
          {/* If currently editing this member, show edit form */}
          {editingMember === member ? (
            <div className={Style.EditMemberForm}>
              <div className={Style.FormTitle}>Uredi člana projekta</div>

              <div className={Style.EditFormField}>
                <label>Ime i prezime:</label>
                <input
                  type="text"
                  name="nameSurname"
                  value={editedData.nameSurname}
                  onChange={handleEditChange}
                  className={Style.EditInput}
                />
              </div>

              <div className={Style.EditFormField}>
                <label>Email:</label>
                <input
                  type="email"
                  name="email"
                  value={editedData.email}
                  onChange={handleEditChange}
                  className={Style.EditInput}
                />
              </div>

              <div className={Style.EditFormField}>
                <label>Postotak na projektu:</label>
                <input
                  type="number"
                  name="thisProjectPercentage"
                  value={editedData.thisProjectPercentage}
                  onChange={handleEditChange}
                  min="0"
                  max="100"
                  className={Style.EditInput}
                />
              </div>

              <div className={Style.OtherProjectsSection}>
                <div className={Style.SectionTitle}>Ostali projekti:</div>

                {editedData.otherProjects.length > 0 ? (
                  editedData.otherProjects.map((project, index) => (
                    <div key={index} className={Style.OtherProjectItem}>
                      <div>{project.otherProjectName}</div>
                      <div>{project.otherProjectPercentage}%</div>
                      <button
                        className={Style.DeleteOtherProjectButton}
                        onClick={() => removeOtherProjectFromEdit(index)}
                      >
                        X
                      </button>
                    </div>
                  ))
                ) : (
                  <p>Nema drugih projekata</p>
                )}

                <div className={Style.AddOtherProjectSection}>
                  <div className={Style.EditFormField}>
                    <input
                      type="text"
                      name="otherProjectName"
                      value={editingOtherProject.otherProjectName}
                      onChange={handleEditOtherProjectChange}
                      placeholder="Naziv projekta"
                      className={Style.SmallEditInput}
                    />
                  </div>
                  <div className={Style.EditFormField}>
                    <input
                      type="number"
                      name="otherProjectPercentage"
                      value={editingOtherProject.otherProjectPercentage}
                      onChange={handleEditOtherProjectChange}
                      placeholder="Postotak"
                      min="0"
                      max="100"
                      className={Style.SmallEditInput}
                    />
                  </div>
                  <button
                    className={Style.AddOtherProjectButton}
                    onClick={addOtherProjectToEdit}
                  >
                    Dodaj
                  </button>
                </div>
              </div>

              {error && <p className={Style.ErrorText}>{error}</p>}

              <div className={Style.EditButtonsContainer}>
                <button className={Style.SaveButton} onClick={saveEditedMember}>
                  Spremi
                </button>
                <button className={Style.CancelButton} onClick={cancelEditing}>
                  Odustani
                </button>
              </div>
            </div>
          ) : (
            /* If not editing, show normal view */
            <>
              {projectEditable && (
                <div className={Style.MemberActionButtons}>
                  <div
                    className={Style.DeleteTeamMemberButton}
                    onClick={deleteTeamMember(member)}
                  >
                    x
                  </div>
                </div>
              )}
              <div className={Style.AdminDashboardProjectTeamMemberInfo}>
                <div style={{ marginRight: "10px" }}>{member.nameSurname}</div>
                <div>{member.thisProjectPercentage}%</div>
                <div style={{ marginLeft: "10px" }}>{member.email}</div>
              </div>

              <div className={Style.AdminDashboardProjectOtherProjectsTitle}>
                OSTALI PROJEKTI:
              </div>
              {member?.otherProjects?.length === 0 && (
                <p style={{ marginLeft: "10px" }}>Nema</p>
              )}
              {member?.otherProjects?.map((project) => (
                <div
                  key={project.otherProjectName}
                  className={Style.AdminDashboardProjectTeamMemberOtherProjects}
                >
                  <div
                    className={Style.AdminDashboardProjectTeamOtherProjectInfo}
                  >
                    {project.otherProjectName} {project.otherProjectPercentage}%
                  </div>
                </div>
              ))}
            </>
          )}
          {projectEditable &&
            !isAddingTeamMemberContainerOpen &&
            !editingMember && (
              <button
                className={Style.EditTeamMemberButton}
                onClick={() => startEditingMember(member)}
              >
                Uredi
              </button>
            )}
        </div>
      ))}

      {/* Unchanged add member form */}
      {isAddingTeamMemberContainerOpen && (
        <>
          <div className={Style.SpecialInputMemberInfo}>
            {/* Existing add member form code... */}
            <div
              className={Style.CloseBtn}
              onClick={() => setIsAddingTeamMemberContainerOpen(false)}
            >
              &#x2715;
            </div>
            <div className={Style.InputTitle}>Ime i prezime</div>
            <input
              className={Style.SpecialInputTextInput}
              ref={nameRef}
              type="text"
              placeholder="Ime i prezime"
            />
            <div className={Style.InputTitle}>E-mail</div>
            <input
              ref={emailRef}
              type="email"
              placeholder="Email"
              className={Style.SpecialInputTextInput}
            />
            <div>
              <div className={Style.InputTitle}>Postotak u projektu</div>
              <input
                className={Style.SpecialInputNumberInput}
                ref={percentageRef}
                type="number"
                min="0"
                max="100"
                placeholder="Postotak na ovom projektu"
              />
            </div>
            <div className={Style.otherProjects}>
              <p>OSTALI PROJEKTI:</p>
              {newOtherProject?.length > 0 ? (
                newOtherProject?.map((project, index) => (
                  <div key={index} className={Style.otherProjectsInfo}>
                    <div>{project.otherProjectName}</div>
                    <div>{project.otherProjectPercentage}%</div>
                    <button
                      className={Style.deleteOtherProject}
                      onClick={() => deleteOtherProject()}
                    >
                      X
                    </button>
                  </div>
                ))
              ) : (
                <p>Nema</p>
              )}
            </div>
            <div className={Style.otherProjectsContainer}>
              <input placeholder="naziv projekta" ref={otherProjectName} />
              <input
                placeholder="postotak"
                type="number"
                min="0"
                max="100"
                ref={otherProjectPercentage}
              />
              <button
                className={Style.addOtherProjectsButton}
                onClick={() => addOtherProjectsButton()}
              >
                Dodaj
              </button>
            </div>
            <button
              className={Style.SpecialInputAddMember}
              onClick={() => addNewTeamMember()}
            >
              DODAJ ČLANA
            </button>
            <p className={Style.errorMessage}>{error}</p>
          </div>
        </>
      )}
      {/* Only show add button if not editing and add form is not open */}
      {projectEditable &&
        !isAddingTeamMemberContainerOpen &&
        !editingMember && (
          <button
            className={Style.AddNewTeamMemberButton}
            onClick={() => setIsAddingTeamMemberContainerOpen(true)}
          >
            Dodaj novu osobu
          </button>
        )}
    </div>
  );
};

export default AdminDashboardProjectTeam;
